import { sfcLoaderService } from '@rrze/vue-sfc-helper'
import { EncoreTemplateService } from '@rrze/vue-encore'
import Vue from 'vue'

import * as sfcVue from 'vue'

import * as axios from 'axios'
import * as lodash from 'lodash'
import * as luxon from 'luxon'
import * as billboardJs from 'billboard.js'
import * as vueClipboard from 'vue-clipboard2'
// import * as diffMatchPatch from 'diff-match-patch'
// import * as vanillaJsoneditor from 'vanilla-jsoneditor'
import * as $rrzeøvueBixins from '@rrze/vue-bixins'
import * as $rrzeøvueBillboard from '@rrze/vue-billboard'
import * as $rrzeøvueEncore from '@rrze/vue-encore'
import * as $rrzeøvueSmi18n from '@rrze/vue-smi18n'
import * as $rrzeøvueJsondiff from '@rrze/vue-jsondiff'
import * as $rrzeøvueManjo from '@rrze/vue-manjo'
import * as $rrzeøvueCmEditor from '@rrze/vue-cm-editor'
import * as $rrzeøvueSlideRefresh from '@rrze/vue-slide-refresh'
import * as $rrzeøvueVisjs from '@rrze/vue-visjs'
import * as jsonEditorVue from 'json-editor-vue'
import * as vueMultiselect from 'vue-multiselect'
import * as vueRouter from 'vue-router'
import * as vuex from 'vuex'
import * as vueUploadComponent from 'vue-upload-component'
import * as vuedraggable from 'vuedraggable'

import * as defaultApiService from '@/services/_appApi.service'
import * as authService from '@/services/auth.service'
import * as authMixin from '@/mixins/auth.mixin'
import * as stompMixin from '@/mixins/stomp.mixin'

sfcLoaderService.addToModuleCache('vue', sfcVue)
sfcLoaderService.addToModuleCache('axios', axios)
sfcLoaderService.addToModuleCache('lodash', lodash)
sfcLoaderService.addToModuleCache('luxon', luxon)
sfcLoaderService.addToModuleCache('billboard.js', billboardJs)
sfcLoaderService.addToModuleCache('vue-clipboard2', vueClipboard)
// sfcLoaderService.addToModuleCache('diff-match-patch', diffMatchPatch)
// sfcLoaderService.addToModuleCache('vanilla-jsoneditor', vanillaJsoneditor)
sfcLoaderService.addToModuleCache('@rrze/vue-bixins', $rrzeøvueBixins)
sfcLoaderService.addToModuleCache('@rrze/vue-billboard', $rrzeøvueBillboard)
sfcLoaderService.addToModuleCache('@rrze/vue-encore', $rrzeøvueEncore)
sfcLoaderService.addToModuleCache('@rrze/vue-smi18n', $rrzeøvueSmi18n)
sfcLoaderService.addToModuleCache('@rrze/vue-jsondiff', $rrzeøvueJsondiff)
sfcLoaderService.addToModuleCache('@rrze/vue-manjo', $rrzeøvueManjo)
sfcLoaderService.addToModuleCache('@rrze/vue-cm-editor', $rrzeøvueCmEditor)
sfcLoaderService.addToModuleCache('@rrze/vue-slide-refresh', $rrzeøvueSlideRefresh)
sfcLoaderService.addToModuleCache('@rrze/vue-visjs', $rrzeøvueVisjs)
sfcLoaderService.addToModuleCache('json-editor-vue', jsonEditorVue)
sfcLoaderService.addToModuleCache('vue-multiselect', vueMultiselect)
sfcLoaderService.addToModuleCache('vue-router', vueRouter)
sfcLoaderService.addToModuleCache('vuex', vuex)
sfcLoaderService.addToModuleCache('vue-upload-component', vueUploadComponent)
sfcLoaderService.addToModuleCache('vuedraggable', vuedraggable)

sfcLoaderService.addToModuleCache('@/services/defaultApi.service', defaultApiService)
sfcLoaderService.addToModuleCache('@/services/auth.service', authService)
sfcLoaderService.addToModuleCache('@/mixins/auth.mixin', authMixin)
sfcLoaderService.addToModuleCache('@/mixins/stomp.mixin', stompMixin)

/** APP SPECIFIC IMPORTS */
// sfcLoaderService.addToModuleCache('@/components/common/LoadingView.vue', loadingView)

const VUE_APP_SFC_DEV_MODE = process.env.VUE_APP_SFC_DEV_MODE ? process.env.VUE_APP_SFC_DEV_MODE.split(',') : []

const VUE_APP_PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH

const sfcOptions = sfcLoaderService.defaultOptions()
sfcOptions.getFile = (url) => {
  if (VUE_APP_SFC_DEV_MODE.includes(url)) {
    return axios.get(`${VUE_APP_PUBLIC_PATH}/_sfc_dev/${url}`).then(res => {
      return res.data
    }).catch(err => console.error(err))
  } else {
    return new EncoreTemplateService(Vue.prototype.$axios).raw(null, { file: url })
      .then(res => {
        return res
      })
      .catch(function (err) {
        console.error(err)
        return Promise.reject(err.status)
      })
  }
}

export const sfcg = (compFile, compName) => sfcLoaderService.getComponent(sfcOptions, compFile, compName)

export const sfcr = (compFile, compName) => sfcLoaderService.loadComponent(sfcOptions, compFile, compName)

export const sfc = (compFile, compName) => {
  const c = sfcg(compFile, compName)
  return { [c.name]: c.comp }
}

export const sfcReload = (compFile, compName, vm) => {
  sfcLoaderService.removeComponent(compName, vm)
  sfcLoaderService.removeFromModuleCache(compFile)
  return sfc(compFile, compName)
}

export const sfcSetup = (Vue) => {
  Vue.prototype.$sfcg = sfcg
  Vue.prototype.$sfcr = sfcr
  Vue.prototype.$sfc = sfc
  Vue.prototype.$sfcReload = function (compFile, compName) { return sfcReload(compFile, compName, this) }
}

export const kebab = sfcLoaderService.kebab

sfcLoaderService.addToModuleCache('@/helpers/sfc.helper', { sfc, sfcg, sfcr, kebab })
